(() => {
  const bind = (root) => {
    if (root.dataset.skTpBound === 'true') return;
    root.dataset.skTpBound = 'true';

    const areaButtons = [...root.querySelectorAll('[data-sk-tp-area]')];
    const areaPanels = [...root.querySelectorAll('[data-sk-tp-area-panel]')];
    const courseButtons = [...root.querySelectorAll('[data-sk-tp-course]')];
    const providers = [...root.querySelectorAll('[data-sk-tp-provider]')];
    const coursePlaceholder = root.querySelector('[data-sk-tp-placeholder="course"]');
    const providerPlaceholder = root.querySelector('[data-sk-tp-placeholder="provider"]');
    const resultHead = root.querySelector('[data-sk-tp-result-head]');
    const resultCourse = root.querySelector('[data-sk-tp-result-course]');

    const setPressed = (buttons, active) => {
      buttons.forEach((button) => {
        const selected = button === active;
        button.classList.toggle('is-active', selected);
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
    };

    const resetProviders = () => {
      providers.forEach((provider) => provider.classList.remove('is-active'));
      resultHead?.classList.remove('is-active');
      providerPlaceholder?.classList.remove('is-hidden');
      setPressed(courseButtons, null);
    };

    areaButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const area = button.dataset.skTpArea;
        setPressed(areaButtons, button);
        areaPanels.forEach((panel) => {
          panel.classList.toggle('is-active', panel.dataset.skTpAreaPanel === area);
        });
        coursePlaceholder?.classList.add('is-hidden');
        resetProviders();
      });
    });

    courseButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const area = button.dataset.skTpCourseArea;
        const subject = button.dataset.skTpCourse;
        setPressed(courseButtons, button);

        let matches = 0;
        providers.forEach((provider) => {
          const subjects = (provider.dataset.skTpSubjects || '')
            .split('|')
            .map((value) => value.trim())
            .filter(Boolean);
          const selected = provider.dataset.skTpProviderArea === area && subjects.includes(subject);
          provider.classList.toggle('is-active', selected);

          if (selected) {
            matches += 1;
            provider.querySelectorAll('[data-sk-tp-book]').forEach((link) => {
              const baseUrl = link.dataset.skTpBaseUrl;
              link.href = `${baseUrl}?subject=${encodeURIComponent(subject)}`;
            });
          }
        });

        if (resultCourse) resultCourse.textContent = button.dataset.skTpCourseLabel || subject;
        resultHead?.classList.toggle('is-active', matches > 0);
        providerPlaceholder?.classList.toggle('is-hidden', matches > 0);
      });
    });

    root.classList.add('sk-tp--ready');
  };

  document.querySelectorAll('[data-sk-tp-root]').forEach(bind);
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.matches?.('[data-sk-tp-root]')) bind(event.target);
    event.target.querySelectorAll?.('[data-sk-tp-root]').forEach(bind);
  });
})();
